module.exports = __webpack_public_path__ + "r-v3/img/screen.01c94bfb.svg";